import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HeadSideMask = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 224.2c0-22.2 3.2-43.6 9.2-63.9l227 165.1c-7.7 12.4-12.2 27-12.2 42.6v144H96c-17.7 0-32-14.3-32-32v-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm258.6 77.9L21 129.3C56.7 53 134.2 0 224 0h32c95.2 0 174.2 69.3 189.4 160.1 2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4 0 4.1-.6 8.1-1.6 11.9H304c-16.9 0-32.5 5.2-45.4 14.1zM352 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-96 288V368c0-26.5 21.5-48 48-48h208l-16 48H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h149.3l-10.7 32H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h128l-1.4 4.2c-8.7 26.1-33.2 43.8-60.7 43.8H256z"
  }));
});
HeadSideMask.displayName = 'HeadSideMask';
export var HeadSideMaskDimensions = {
  height: 512,
  width: 512
};